import {
  collection,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';

export default async function fetchLatestProcessLog({
  project,
  process,
  press = null,
  production = null,
  pPart = null,
  stepPPartId = null,
  orderByField = 'start',
}) {
  const whereClauses = [
    where('project', '==', project),
    where('process', '==', process),
  ];

  if (pPart) {
    whereClauses.push(where('pPart', '==', pPart));
  }

  if (press) {
    whereClauses.push(where('press', '==', press));
  }

  if (stepPPartId) {
    whereClauses.push(where('stepPPartId', '==', stepPPartId));
  }

  if (typeof production === 'boolean') {
    whereClauses.push(where('production', '==', production));
  }

  const querySnapshot = await getDocs(query(
    collection(getFirestore(), 'process_logs'),
    ...whereClauses,
    orderBy(orderByField, 'desc'),
    limit(1),
  ));

  if (querySnapshot.empty) {
    return null;
  }

  return {
    id: querySnapshot.docs[0].id,
    ...querySnapshot.docs[0].data(),
  };
}
